<template>
    <div>
        <h3 class="title is-3" style="margin-top:8px;">
            <router-link to="/tools/explorer">
                <b-icon icon="chevron-left" size="is-small"></b-icon>
            </router-link> &nbsp;
            {{slug}}
        </h3>

        <div class="box">
            <h5 class="title is-5">Retrieve Data</h5>
            <div class="buttons">
                <button class="button is-primary" @click="get('news')">News</button>
                <button class="button is-primary" @click="get('videos')">Videos</button>
                <button v-if="isMajor" class="button is-primary" @click="get('fixtures')">
                    Fixtures
                </button>
                <button v-if="isMajor" class="button is-primary" @click="get('results')">
                    Results
                </button>
                <button v-if="isMajor" class="button is-primary" @click="get('logs')">
                    Logs
                </button>
                <button v-if="isMinor" class="button is-primary" @click="get('schedule')">
                    Schedule
                </button>
            </div>
        </div>
        
        <!-- match detail -->
        <div class="box" v-if="fixtureIds && fixtureIds.length > 0">
            <h5 class="title is-5">View Fixture Match Detail</h5>
            <div class="buttons">
                <button :key="id" v-for="id in fixtureIds" class="button is-primary" @click="match(id)">
                    {{id}}
                </button>
            </div>
        </div>

        <div v-if="category === 'motorsport' && scheduleIds && scheduleIds.length > 0" class="box">
            <h5 class="title is-5">View Grid</h5>
            <div class="buttons">
                <button :key="id" v-for="id in scheduleIds" class="button is-primary" @click="grid(id)">
                    {{id}}
                </button>
            </div>
            <h5 class="title is-5">View Results</h5>
            <div class="buttons">
                <button :key="id" v-for="id in scheduleIds" class="button is-primary" @click="motorsportResults(id)">
                    {{id}}
                </button>
            </div>
        </div>

        <div class="notification is-warning" v-if="data === false">
            Seems like there was a problem retrieving the data.
        </div>
        <loading v-else-if="!data"></loading>
        <div class="box" v-else>
            <h5 class="title is-5">Data</h5>
            <tree-view :data="data" :options="{rootObjectKey: currentDataset}"></tree-view>
        </div>
        

    </div>
</template>

<script>
import { GET_EXPLORER_DATA } from "@/store/actions";
import { SET_EXPLORER_DATA } from "@/store/mutations";
import Loading from "@/components/Loading";

export default {
  name: "feed-explorer",
  components: {
    Loading
  },
  data() {
    return {
      currentDataset: null
    };
  },
  mounted() {
    this.$store.commit(SET_EXPLORER_DATA, {});
    this.currentDataset = null;
  },
  computed: {
    category() {
      return this.$route.params.category;
    },
    slug() {
      return decodeURIComponent(this.$route.params.slug);
    },
    isMajor() {
      const { category } = this;
      return ["football", "rugby", "cricket"].indexOf(category) !== -1;
    },
    isMinor() {
      const { category } = this;
      return ["motorsport", "tennis", "golf"].indexOf(category) !== -1;
    },
    data() {
      return this.$store.state.explorer.data;
    },
    base() {
      const { category, slug } = this;
      if (category === "minor") {
        return `supersport://${slug}`;
      }

      return `supersport://${category}/${slug}`;
    },
    baseCategory() {
      const { category } = this;
      return `supersport://${category}`;
    },
    fixtureIds() {
      const { data, currentDataset } = this;

      if (!data || !Array.isArray(data) || currentDataset !== "fixtures") {
        return null;
      }

      return data.map(x => x.MatchID);
    },
    scheduleIds() {
      const { data, category, currentDataset } = this;

      if (
        !data ||
        !Array.isArray(data) ||
        currentDataset !== "schedule" ||
        category !== "motorsport"
      ) {
        return null;
      }

      return data.map(x => x.Id);
    }
  },
  methods: {
    get(endpoint) {
      this.currentDataset = endpoint === "results" ? "fixtures" : endpoint;
      this.$store.dispatch(GET_EXPLORER_DATA, `${this.base}/${endpoint}`);
    },
    match(id) {
      this.currentDataset = "fixture";
      this.$store.dispatch(
        GET_EXPLORER_DATA,
        `${this.baseCategory}/matchdetails/${id}`
      );
    },
    grid(id) {
      this.currentDataset = "grid";
      this.$store.dispatch(GET_EXPLORER_DATA, `${this.base}/grid/${id}`);
    },
    motorsportResults() {
      this.currentDataset = "result";
      this.$store.dispatch(GET_EXPLORER_DATA, `${this.base}/results/${id}`);
    }
  }
};
</script>

<style>
.tree-view-item-value-null {
  color: crimson;
}
.tree-view-item-value-number {
  color: blueviolet;
}
.tree-view-item-value-string {
  color: green;
}
.tree-view-item-value-boolean {
  color: blue;
}
</style>
